import api from './api';

// Rızalarım — backend `v1/my-consents` (listeleme + kendi rızasını geri çekme). Kimlik
// gönderilmez; sunucu çağıranın kişi kaydını kimlik ailesinden çözer.
//
// Kişi kaydı (LifecyclePerson) olmayan çağırana backend 404 `kvkk.consent.personNotFound`
// döner; Rızalarım bunu "rıza yok" BOŞ durumu olarak gösterir. api.js başarısız GET'i
// varsayılan olarak EMPTY_RESPONSE'a indirger (mesaj kaybolur → "yüklenemedi") ve toast
// basar. `passErrorBody` gövdeyi geçirir; `skipErrorToast` YALNIZ bu anahtarı susturur,
// başka her hata toast'lanmaya devam eder. Sözleşme: kvkkService.test.js.
export const getMyConsents = () => api.get('/v1/my-consents', {
  passErrorBody: true,
  skipErrorToast: ['kvkk.consent.personNotFound'],
});
export const revokeMyConsent = (id, reason) => api.post(`/v1/my-consents/${id}/revoke`, { reason });

// KVKK veri talebi — self-servis. Çalışan kaydı olmayan çağırana backend 404
// `kvkk.request.employeeNotFound` döner; KVKK Taleplerim bunu "bu hesap bir çalışan kaydına
// bağlı değil" durumu olarak gösterir ve "Yeni Talep" sunmaz. Rızalarım ile aynı kalıp:
// gövde geçer, YALNIZ bu anahtar susturulur. Sözleşme: kvkkService.test.js.
export const getMyKvkkRequests = () => api.get('/v1/my-kvkk-requests', {
  passErrorBody: true,
  skipErrorToast: ['kvkk.request.employeeNotFound'],
});
export const createMyKvkkRequest = (data) => api.post('/v1/my-kvkk-requests', data);

// KVKK veri talebi — İK yüzü (sınıf düzeyinde EM.Write).
export const getKvkkRequests = (queryString) => api.get(`/v1/kvkk-requests?${queryString}`);
export const getKvkkRequest = (id) => api.get(`/v1/kvkk-requests/${id}`);
export const changeKvkkRequestStatus = (id, data) => api.patch(`/v1/kvkk-requests/${id}/status`, data);
